// extracted by mini-css-extract-plugin
export var caption = "PersonalData-module--caption--a3bec";
export var companyLink = "PersonalData-module--companyLink--b824d";
export var fadeInAnimation = "PersonalData-module--fadeInAnimation--ab8b7";
export var linkedinIcon = "PersonalData-module--linkedinIcon--dd5d6";
export var name = "PersonalData-module--name--db948";
export var photo = "PersonalData-module--photo--70000";
export var position = "PersonalData-module--position--be004";
export var wrapper = "PersonalData-module--wrapper--2e2a8";